import { resolveJsonata } from '@the-platform-company/jsonata-utilities'
import { deepEqual } from 'fast-equals'
import { useContext } from 'react'
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector'
import { StateContext } from './state-provider'
import { State, Store } from './types'

export const useStateExpression = (
  expression: unknown,
  opts?: {
    onError?: (error: unknown) => void
    before?: (expression: unknown, snapshot: State, store: Store) => State
  }
) => {
  const context = useContext(StateContext)

  if (!context) {
    throw new Error(
      'withResolvedProperties must be used within a StateProvider'
    )
  }

  return useSyncExternalStoreWithSelector(
    context.store.subscribe,
    context.store.getState,
    null,
    (snapshot) =>
      resolveJsonata(
        opts?.before
          ? opts?.before(expression, snapshot, context.store)
          : expression,
        snapshot,
        {
          onError: opts?.onError,
        }
      ),
    deepEqual
  )
}
